module.exports = __webpack_public_path__ + "static/media/placeholder-choice.c6903f27.svg";